import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload'

const resourceName = 'REOccurence'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetByNameUnidade = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByNameUnidade/${name}`, data, config)
const GetAll = (data = {}, typeAccess, limit, index, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAll?limit=${limit}&index=${index}`, data, typeAccess, config)
const GetProblemaRaiz = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetProblemaRaiz`, data, config)
const GetStatusOcorrencia = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetStatusOcorrencia`, data, config)
const GetTriagemById = (id, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetTriagemById/${id}`, config)
const GetVistoriaById = (id, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetVistoriaById/${id}`, config)
const GetPatologia = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetPatologia`, data, config)
const GetByNameMorado = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByNameMorado/${name}`, data, config)
const DownloadPDF = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/lista-chamado/download/${id}`, data, config)
const GetPatologiaValue = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetPatologiaValue`, data, config)
const PutTriagem = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/atualizar/triagem/`, data, config)
const PutVistoria = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/atualizar/vistoria`, data, config)
const Inserir = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Inserir`, data, config)
const GetTecnicoAndHours = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetTecnicoAndHours`, data, config)
const GetHourWithTennicaid = (tecnicoid = {}, data, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetHourWithTennicaid/${tecnicoid}`, data, config)
const GetPatologias = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetPatologias`, data, config) // By filtro
const GetPatologiasPesonalizadoSemanal = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetPatologiasPesonalizadoSemanal`, data, config) // By filtro
const GetPatologiaMaior = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetPatologiaMaior`, data, config)
const GetPatologiaPdf = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetPatologiaPdf`, data, config)
const GetEmpreendimentoPdf = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoPdf`, data, config)
const GetPatologiasPdf = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetPatologiasPdf`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/Delete/${id}`, data, config)
const NextStatus = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/NextStatus/${id}`, data, config)
const ReproveStatus = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/ReproveStatus/${id}`, data, config)
const ReturnStatus = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/ReturnStatus/${id}`, data, config)
const GetKanban = (data = {}, typeAccess, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetKanban`, data, typeAccess, config)
const ChangeKanban = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/ChangeKanban`, data, config)
const SendFileVistoriaTecnica = (id, data = {}, config = {}) => APIClientUpload.post(`${APIBaseURLRealEstate}/${resourceName}/SendFileVistoriaTecnica/${id}`, data, config)
const DeleteFileVistoriaTecnica = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/DeleteFileVistoriaTecnica/${id}`, data, config)
const DownloadFileVistoria = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/DownloadFileVistoria/${id}`, data, config)
const GetInfoPdf = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetInfoPdf/${id}`, data, config)
const GetNovaUnidade = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetNovaUnidade`, data, config)
const GetStatusRelatorioInsumos = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetStatusRelatorioInsumos`, data, config)

const OcurrenceRepository = {
  GetAll,
  GetByNameUnidade,
  GetPatologiasPesonalizadoSemanal,
  GetPatologiaMaior,
  GetPatologiaPdf,
  GetEmpreendimentoPdf,
  GetPatologiasPdf,
  GetProblemaRaiz,
  GetPatologia,
  GetTriagemById,
  GetVistoriaById,
  GetStatusOcorrencia,
  GetByNameMorado,
  DownloadPDF,
  PutTriagem,
  Inserir,
  PutVistoria,
  GetTecnicoAndHours,
  GetHourWithTennicaid,
  ReproveStatus,
  GetPatologias,
  SendFileVistoriaTecnica,
  DeleteFileVistoriaTecnica,
  GetInfoPdf,
  Delete,
  NextStatus,
  ReturnStatus,
  GetKanban,
  ChangeKanban,
  DownloadFileVistoria,
  GetPatologiaValue,
  GetNovaUnidade,
  GetStatusRelatorioInsumos
}

export default OcurrenceRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/ocurrence.js